import { DOCUMENT_THEME_ATTRIBUTE } from './browser.ts';
import { DARK_SCHEME_QUERY, THEME_COOKIE } from './preference.ts';

/**
 * Runs in `<head>` before the page paints: resolves the `wh-theme` cookie as `resolveThemePreference` does and puts
 * the theme on `<html>`, so the first paint and the app's first render already agree. Plain ES5 with no imports, and
 * inline, so it costs no request; a Content-Security-Policy allows it by `THEME_BOOT_SCRIPT_HASH`.
 */
export const THEME_BOOT_SCRIPT = [
  '(function () {',
  '  try {',
  `    var match = document.cookie.match(/(?:^|;\\s*)${THEME_COOKIE}=([^;]*)/);`,
  "    var preference = match ? match[1] : '';",
  "    var dark = preference === 'dark' ||",
  `      (preference === 'auto' && window.matchMedia(${JSON.stringify(DARK_SCHEME_QUERY)}).matches);`,
  `    document.documentElement.setAttribute(${JSON.stringify(DOCUMENT_THEME_ATTRIBUTE)}, dark ? 'noir' : 'meadow');`,
  '  } catch (error) {',
  `    document.documentElement.setAttribute(${JSON.stringify(DOCUMENT_THEME_ATTRIBUTE)}, 'meadow');`,
  '  }',
  '})();',
].join('\n');

/**
 * The CSP `script-src` source that allows `THEME_BOOT_SCRIPT` and nothing else inline. A constant, so a page can
 * show the policy too; boot-script.spec.ts checks it against the script, and gives the new value when it changes.
 */
export const THEME_BOOT_SCRIPT_HASH = "'sha256-ft3JNf4X62fqHGgVQwSIagN/btR6jzoMz9JwOaPxgGI='";
